import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-07bc4f15"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "center" }
const _hoisted_2 = { class: "name" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-field" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "description-text" }),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_4 = { class: "features-header" }
const _hoisted_5 = { class: "features-container" }
const _hoisted_6 = { class: "feature-name" }
const _hoisted_7 = { class: "feature-description" }

import Typed from "typed.js";
import {onMounted, watch, WritableComputedRef} from "vue";
import UFOLogoDark from "@/assets/logo-v2-dark.png";
import UFOLogoLight from "@/assets/logo-v2-light.png";
import config from "@/config.json";
import {Language} from "@/types/Language";
import i18n from "@/plugins/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const location = window.location.origin
let typed: Typed;
function startTyped() {
  typed?.destroy();
  typed = new Typed('.description-text', {
    strings: i18n.global.tm('Home.descriptions').map(desc => i18n.global.rt(desc)),
    typeSpeed: 50,
    backSpeed: 50,
    shuffle: true,
    backDelay: 3000,
    loop: true,
    cursorChar: '__'
  })
}
onMounted(startTyped)
watch(() => (i18n.global.locale as WritableComputedRef<Language>).value, startTyped)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(" UFO "),
      _createVNode(_component_router_link, {
        class: "primary-link",
        to: "/v2"
      }, {
        default: _withCtx(() => [
          _createTextVNode("V2")
        ]),
        _: 1
      })
    ]),
    (_ctx.$vuetify.theme.current.dark)
      ? (_openBlock(), _createBlock(_component_v_img, {
          key: 0,
          src: _unref(UFOLogoDark),
          class: "logo item-center"
        }, null, 8, ["src"]))
      : (_openBlock(), _createBlock(_component_v_img, {
          key: 1,
          src: _unref(UFOLogoLight),
          class: "logo item-center"
        }, null, 8, ["src"])),
    _hoisted_3,
    _createVNode(_component_v_btn, {
      href: `https://discord.com/api/oauth2/authorize?client_id=${_unref(config).botID}&redirect_uri=${encodeURIComponent
    (_unref(location) + '/landing')}&response_type=code&permissions=1515519995134&scope=bot`,
      size: "x-large",
      color: "primary",
      class: "invite"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_icon, {
          class: "mr-2",
          size: "large"
        }, {
          default: _withCtx(() => [
            _createTextVNode("discord")
          ]),
          _: 1
        }),
        _createTextVNode(_toDisplayString(_ctx.$t('Home.invite')), 1)
      ]),
      _: 1
    }, 8, ["href"]),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('Home.featuresTitle')), 1),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$tm('Home.features'), (feature) => {
        return (_openBlock(), _createBlock(_component_v_card, {
          class: "feature",
          color: "block"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$rt(feature.name)), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$rt(feature.description)), 1)
          ]),
          _: 2
        }, 1024))
      }), 256))
    ])
  ]))
}
}

})